import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import API from "../../services/api";
import { toast } from "react-toastify";
const initialState = {
  MessageCentreData: {},
  status: StatusCode.IDLE,
};
const {
  GET_NOTIFICATION,
  ARTICLEREGISTRATION,
  CREATE_NOTIFICATION,
  NOTIFICATION,
  UPDATEARTICAL,
  NOTIFICATION_DELETE,
} = ApiEndPoint;

export const messageCentreSlice = createSlice({
  name: "MessageCentre",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessageCentreData.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(fetchMessageCentreData.fulfilled, (state, action) => {
        state.MessageCentreData = action.payload.data;
        state.status = StatusCode.IDLE;
      })
      .addCase(fetchMessageCentreData.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      .addCase(RegisterEditArticle.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(RegisterEditArticle.fulfilled, (state, action) => {
        state.MessageCentreData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(RegisterEditArticle.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      })
      // notification
      .addCase(RegisterEditNotification.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(RegisterEditNotification.fulfilled, (state, action) => {
        state.MessageCentreData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(RegisterEditNotification.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      });
  },
});

export const {} = messageCentreSlice.actions;
export default messageCentreSlice.reducer;

export const fetchMessageCentreData = createAsyncThunk(
  "admin/get/message-centre",
  async () => {
    try {
      const res = await API.get(GET_NOTIFICATION);
      if (res.data?.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.error("Failed to fetch message centre  data:", error);
      throw error;
    }
  }
);

export const getMessageDetails = createAsyncThunk(
  "/user/get-message-detail",
  async (data) => {
    try {
      const res = await API.get(`${NOTIFICATION}${data.id}`);
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const RegisterEditArticle = createAsyncThunk(
  "/user/edit-article",
  async (data) => {
    try {
      const res = await API.post(`${ARTICLEREGISTRATION}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data?.status === 200) {
        toast.success(res.data?.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const updateMsgArticle = createAsyncThunk(
  "/user/update-message-article",
  async (data) => {
    try {
      const res = await API.put(`${UPDATEARTICAL}`, data);
      if (res.data?.status === 200) {
        toast.success(res.data?.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const updateMsgNotification = createAsyncThunk(
  "/user/update-message-notification",
  async (data) => {
    try {
      const res = await API.patch(`${NOTIFICATION}${data.id}`, data);
      if (res.data?.status === 200) {
        toast.success(res.data?.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const RegisterEditNotification = createAsyncThunk(
  "/user/edit-notification",
  async (data) => {
    try {
      const res = await API.post(`${CREATE_NOTIFICATION}`, data);
      if (res.data?.status === 200) {
        toast.success(res.data?.data?.message);
      }
      return res.data;
    } catch (error) {
      toast.error(error?.data?.message);
    }
  }
);

export const deleteMessageCenterData = createAsyncThunk(
  "admin/delete/message-center",
  async (data) => {
    try {
      const res = await API.delete(`${NOTIFICATION_DELETE}`, {
        data: data,
      });
      if (res.status === 200) {
        toast.success(res?.data?.message);
        return res?.data;
      }
    } catch (error) {
      toast.error(error.data?.message);
      throw error;
    }
  }
);
